export enum PatientBannerEnum {
  defaultMobileHeight = 220,
  defaultDesktopHeight = 130,
  extendedMobileHeight = 280,
  extendedDesktopHeight = 250
}
